import { Collapse as AntdCollapse, type CollapsePanelProps } from 'antd'

export const Panel = (props: CollapsePanelProps) => (
  <AntdCollapse.Panel {...props} />
)
